import { Trans, useLingui } from '@lingui/react';
import { Identity } from '@startuptools/business-ui/identity/Identity';
import { SelectShareClass } from '../../../components/select-share-class/SelectShareClass';
import { type Control, Controller, type UseFormRegister, type UseFormWatch } from 'react-hook-form';
import { type GqlMeetingParticipantQuery, type GqlShareClass } from '../../../graphql/react-operations';
import { Stack } from '@startuptools/ui/Stack';
import { FormControl } from '@startuptools/ui/FormControl';
import { FormLabel } from '@startuptools/ui/FormLabel';
import { NumericFormatInput } from '@startuptools/ui/NumericFormatInput';
import { type FormInputs as ShareClassFormInputs } from '../../../components/select-share-class/SelectShareClass';

export interface FormInputs extends ShareClassFormInputs {
  numberOfShares: string;
  numberOfVotes: string;
  // selectedShareClassName: string | null;
  // newShareClassName: string;
  // newShareClassVoteWeight: string;
}

export const VotingListShareForm = ({
  watch,
  register,
  meetingParticipant,
  shareClasses,
  defaultShareClassName,
  loading,
  control,
}: {
  watch: UseFormWatch<FormInputs>;
  register: UseFormRegister<FormInputs>;
  meetingParticipant: GqlMeetingParticipantQuery['meetingParticipant'];
  shareClasses: GqlShareClass[];
  defaultShareClassName: string | undefined;
  loading: boolean;
  control: Control<FormInputs>;
}) => {
  const { i18n } = useLingui();

  return (
    <Stack gap={3}>
      <Identity identity={meetingParticipant.identity} />
      <SelectShareClass
        watch={watch}
        register={register}
        shareClasses={shareClasses}
        control={control as unknown as Control<ShareClassFormInputs>}
        loading={loading}
        defaultShareClassName={defaultShareClassName}
        disabledShareClasses={
          meetingParticipant.meetingParticipantShares.map(mps => mps.shareClass?.name).filter(Boolean) as string[]
        }
      />
      <Controller
        control={control}
        name="numberOfShares"
        render={({ field }) => (
          <FormControl>
            <FormLabel>
              <Trans id="Number of shares" />
            </FormLabel>
            <NumericFormatInput {...field} lang={i18n.locale} disabled={loading} />
          </FormControl>
        )}
      />

      <Controller
        control={control}
        name="numberOfVotes"
        render={({ field }) => (
          <FormControl>
            <FormLabel>
              <Trans id="Number of votes" />
            </FormLabel>
            <NumericFormatInput {...field} lang={i18n.locale} disabled={loading} />
          </FormControl>
        )}
      />
    </Stack>
  );
};
